import { IErrorsInput, ValidatorHelper } from "../helpers/ValidatorHelper";
import { LookupDataService } from "../services/LookupDataService";
import { CountryService } from "../services/CountryService";
import { EmployeeService } from "../services/EmployeeService";
import { StaffService } from "../services/StaffService";
import { enumSharedMsgs } from "../helpers/common.constants";
import { PayrollService } from "../services/PayrollService";
import { OfficeService } from "../services/OfficeService";

export default class PayrollActions {
  async InitAsync(Record: any) {
    let responseLookup = await new LookupDataService().GetAll();
    let officeLookup = await new OfficeService().GetActiveOffices(Record);

    let responses = [responseLookup, officeLookup];

    //napravi validacija
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async ExportAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Export(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async SearchAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Search(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async ManageAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Manage(Record);
    let responseExchangeRates = await new PayrollService().GetExchangeRates(
      Record
    );
    let responses = [response, responseExchangeRates];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async EmployeeOverviewAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().EmployeeOverview(Record);
    let responseExchangeRates = await new PayrollService().GetExchangeRates(
      Record
    );
    let responses = [response, responseExchangeRates];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async GetExchangeRatesAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().GetExchangeRates(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async SaveAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Save(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async UnlockAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Unlock(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async ApprovedAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Approved(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async DisapprovedAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Disapproved(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async SubmitAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Submit(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }

  async VerifyAsync(Record: any) {
    //napravi validacija
    let response = await new PayrollService().Verify(Record);
    let responses = [response];
    let output = new ValidatorHelper().validateServerResponses(responses);
    return output;
  }


  async UploadFileAsync(args : any) {
    let response = await new PayrollService().UploadFile(args);
    let responses = [response];
    return new ValidatorHelper().validateServerResponses(responses); //procitaj najgore kako raboti
  }
  
}
